const FilterByDays = [
    {
        name: "all",
        value: null,
    },{
        name: "year",
        value: -365
    },{
        name: "month",
        value: -31
    }, {
        name: "week",
        value: -7
    },{
        name: "3day",
        value: -3
    },{
        name: "today",
        value: -0
    }
];


export default FilterByDays;